export const NAME_SESSION = 'session';

const getSessionData = () => {
  return localStorage.getItem(NAME_SESSION);
};

export function getUser() {
  const sessionData = getSessionData();
  if (sessionData) {
    try {
      return JSON.parse(sessionData);
    } catch (err) {
      console.error('[getUser] Error parsing sessionData', err);
      return null;
    }
  }
  return null; // no hay sesión
}

export function setRefreshToken(newToken) {
  const sessionData = getUser() || {};

  setUser({
    ...sessionData,
    access_token: newToken.access_token,
    refresh_token: newToken.refresh_token,
    expiration: newToken.expiration,
  });
}

export function setUser(user) {
  if (user) {
    localStorage.setItem(NAME_SESSION, JSON.stringify(user));
  } else {
    localStorage.removeItem(NAME_SESSION);
  }
}
